import { useState } from "react";
import { useSelector } from "react-redux";
import editIcon from "../../../../../images/icons/edit.svg";
import trashIcon from "../../../../../images/icons/delete.svg";
import DeleteModal from "../../../../common/DeleteModal";
import BannerService from "../../../../../services/BannerService";

const CardItem = ({ item, setAddModal, index, setItem, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);
	const bannerService = new BannerService();

	return (
		<tr key={index} className="text-center">
			<td>{item[`title_${lang}`] || "-"}</td>
			<td>
				<img
					src={item?.image}
					className="cursor-pointer border-radius-5"
					alt="view"
					width={80}
				/>
			</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{isExist("update_cms") && (
						<img
							src={editIcon}
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
					{isExist("delete_cms") && (
						<img
							src={trashIcon}
							onClick={() => setDeleteModal(true)}
							className="cursor-pointer"
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item[`title_${lang}`]}
					deletedItem={item}
					modelService={bannerService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
